import { useCallback } from 'react';

type EventPayload = {
  label?: string;
  category?: string;
  value?: number;
};
export const useEventTracker = (action: string) =>
  useCallback(
    ({ label, category, value }: EventPayload) => {
      if (!window.gtag) {
        return console.info('gtag not found.');
      }
      window.gtag('event', action, {
        event_category: category,
        event_label: label,
        value: value,
      });
    },
    [action],
  );
